import { apiClient } from '@core/api/ApiClientFactory';

export interface ZoneTrackerDailyData {
    intervalStart: string;
    max: number;
    avg: number;
    min: number;
}

export interface ZoneTrackerEntriesData {
    intervalStart: string;
    entries: number;
}

export interface ZoneTrackerDwellTimeData {
    range: string;
    count: number;
}

export interface ZoneTrackerOverviewData {
    date: string;
    count: number;
}

export const zoneTrackerService = {
    /**
     * Load daily details for zone tracker
     */
    async loadDailyDetails(
        deviceId: string,
        moduleId: string,
        start: string,
        end: string,
        interval: number
    ): Promise<ZoneTrackerDailyData[]> {
        try {
            console.log(`[ZoneTrackerService] Loading daily details for module: ${moduleId}`);
            const response = await apiClient.get<ZoneTrackerDailyData[]>(
                `statistics/zonetracker/${deviceId}/${moduleId}/${start}/${end}/${interval}`
            );
            console.log(`[ZoneTrackerService] Daily details loaded:`, response.data);
            return response.data;
        } catch (error) {
            console.error('[ZoneTrackerService] Error loading daily details:', error);
            throw error;
        }
    },

    /**
     * Load entries data for zone tracker
     */
    async loadEntries(
        deviceId: string,
        moduleId: string,
        start: string,
        end: string,
        interval: number
    ): Promise<ZoneTrackerEntriesData[]> {
        try {
            console.log(`[ZoneTrackerService] Loading entries for module: ${moduleId}`);
            const response = await apiClient.get<ZoneTrackerEntriesData[]>(
                `statistics/zonetracker/zoneentriesexits/${deviceId}/${moduleId}/${start}/${end}/${interval}`
            );
            console.log(`[ZoneTrackerService] Entries loaded:`, response.data);
            return response.data;
        } catch (error) {
            console.error('[ZoneTrackerService] Error loading entries:', error);
            throw error;
        }
    },

    /**
     * Load dwell time data for zone tracker
     */
    async loadDwellTime(
        deviceId: string,
        moduleId: string,
        start: string,
        end: string,
        interval: string
    ): Promise<ZoneTrackerDwellTimeData[]> {
        try {
            console.log(`[ZoneTrackerService] Loading dwell time for module: ${moduleId}`);
            const response = await apiClient.get<ZoneTrackerDwellTimeData[]>(
                `statistics/zonetracker/dwellTime/${deviceId}/${moduleId}/${start}/${end}/${interval}`
            );
            console.log(`[ZoneTrackerService] Dwell time loaded:`, response.data);
            return response.data;
        } catch (error) {
            console.error('[ZoneTrackerService] Error loading dwell time:', error);
            throw error;
        }
    },

    /**
     * Load overview data for zone tracker
     */
    async loadOverview(
        deviceId: string,
        moduleId: string,
        start: string,
        end: string
    ): Promise<ZoneTrackerOverviewData[]> {
        try {
            console.log(`[ZoneTrackerService] Loading overview for module: ${moduleId}`);
            const response = await apiClient.get<ZoneTrackerOverviewData[]>(
                `statistics/zonetracker/zoneentries/${deviceId}/${moduleId}/${start}/${end}`
            );
            console.log(`[ZoneTrackerService] Overview loaded:`, response.data);
            return response.data;
        } catch (error) {
            console.error('[ZoneTrackerService] Error loading overview:', error);
            throw error;
        }
    }
};
